
import React from "react";

const Query = () =>{
    return(
        <div className="card">
            <div className="card-header">
                <h5 className="mb-0">Query</h5>
            </div>
            <div className="card-block">
                Query
            </div>
        </div>
    );
}


export default Query;